var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "neu-card-questions-and-answers", attrs: { cols: "12" } },
    [
      _c(
        "div",
        { staticClass: "my-auto" },
        [
          _c("h3", { domProps: { innerHTML: _vm._s(_vm.question) } }),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-4 justify-center" },
            [
              _vm.answers.length === 0
                ? _c(
                    "b-col",
                    { attrs: { cols: "10", sm: "6", lg: "3" } },
                    [
                      _c("base-input", {
                        staticClass: "form-group",
                        attrs: {
                          disabled: _vm.readOnly,
                          value: _vm.healthVarValue,
                          zeroMarginBottom: "",
                          type: _vm.inputType,
                          min: 0,
                          placeholder: _vm.$t("value")
                        },
                        on: {
                          input: function($event) {
                            return _vm.$emit("inputSelected", $event)
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            _vm.VAR_UNITS[_vm.answerVarName]
                              ? {
                                  key: "append",
                                  fn: function() {
                                    return [
                                      _vm._v(
                                        _vm._s(_vm.VAR_UNITS[_vm.answerVarName])
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              : null
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.answers, function(item) {
                return _vm.answers.length
                  ? _c("clinic-history-quiz-answer", {
                      key:
                        _vm.$i18nHelpers.normalize(item.name) +
                        "-" +
                        item.answerId,
                      attrs: {
                        readOnly: _vm.readOnly,
                        quizAnswersColumnsAnchor: _vm.quizAnswersColumnsAnchor,
                        id: item.answerId,
                        answer: _vm.$i18nHelpers.normalize(item.name),
                        answersSelected: _vm.answersSelected
                      },
                      on: {
                        elementSelected: function($event) {
                          return _vm.$emit("elementSelected", {
                            answerId: item.answerId,
                            clinicHistoryValue: item.clinicHistoryValue
                          })
                        }
                      }
                    })
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.showDontKnowAnswer && !_vm.readOnly
                ? _c("clinic-history-quiz-answer", {
                    attrs: {
                      id: _vm.defaultAnswer.id,
                      answer: _vm.defaultAnswer.name,
                      answersSelected: _vm.answersSelected
                    },
                    on: {
                      elementSelected: function($event) {
                        return _vm.$emit("elementSelected", {
                          answerId: _vm.defaultAnswer.id,
                          emptyValue: true
                        })
                      }
                    }
                  })
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a87f8502", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a87f8502","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/clinicHistory/quiz/ClinicHistoryQuizForm.vue
// module id = 3037
// module chunks = 32 63